module.exports = __webpack_public_path__ + "static/img/kongtiao-zidong.6dd6b343.png";